export default "__VITE_ASSET__5808c61d__"